@let hasTrainingQualificationDeletePermission =
  can(RoleAction.Delete, RolePermissionSubject.QualificationTraining);
@let selectedQualificationTrainings =
  (selectedQualificationTrainings$ | async) || [];
<button
  nz-button
  nzDanger
  nzType="text"
  [disabled]="
    !hasTrainingQualificationDeletePermission ||
    !selectedQualificationTrainings?.length
  "
  nz-tooltip
  [nzTooltipTitle]="
    !hasTrainingQualificationDeletePermission
      ? ('general.no_permissions' | translate)
      : ''
  "
  (click)="
    showTrainingQualificationDeleteOrCancelModal(selectedQualificationTrainings)
  "
>
  @if (!areDigitalProviders() && !areNonDigitalProviders()) {
    {{ 'page.training-qualifications.delete' | translate }} &
    {{ 'page.training-qualifications.cancel' | translate }}
  } @else if (areDigitalProviders()) {
    {{ 'page.training-qualifications.cancel' | translate }}
  } @else if (areNonDigitalProviders()) {
    {{ 'page.training-qualifications.delete' | translate }}
  }
  @if (selectedQualificationTrainings?.length) {
    ({{ selectedQualificationTrainings?.length }})
  }
</button>
